import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle, Home } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/pricing');
      return;
    }

    checkPaymentStatus(sessionId);
  }, [location]);

  const checkPaymentStatus = async (sessionId) => {
    let attempts = 0;
    const maxAttempts = 5;
    const pollInterval = 2000;

    const poll = async () => {
      if (attempts >= maxAttempts) {
        toast.error('No se pudo verificar el pago. Por favor contacta soporte.');
        setChecking(false);
        return;
      }

      try {
        const token = localStorage.getItem('session_token');
        const response = await axios.get(
          `${API}/payments/checkout/status/${sessionId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.data.payment_status === 'paid') {
          setPaymentStatus('paid');
          setChecking(false);
          toast.success('¡Pago completado exitosamente!');
          return;
        } else if (response.data.status === 'expired') {
          setPaymentStatus('expired');
          setChecking(false);
          toast.error('La sesión de pago ha expirado');
          return;
        }

        attempts++;
        setTimeout(poll, pollInterval);
      } catch (error) {
        console.error(error);
        attempts++;
        setTimeout(poll, pollInterval);
      }
    };

    poll();
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50 flex items-center justify-center p-4">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-xl font-medium text-slate-700">Verificando tu pago...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg border border-slate-200 p-8 text-center">
        <div className="w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-emerald-600" />
        </div>
        <h1 className="text-3xl font-extrabold font-heading mb-3">¡Pago Exitoso!</h1>
        <p className="text-slate-600 mb-8">
          Tu suscripción ha sido activada. Ya puedes disfrutar de todas las funciones premium.
        </p>
        <Button
          onClick={() => navigate('/dashboard')}
          className="w-full rounded-full bg-indigo-600 hover:bg-indigo-700 text-white py-6 text-lg font-bold shadow-lg"
          data-testid="goto-dashboard-btn"
        >
          <Home className="w-5 h-5 mr-2" />
          Ir al Dashboard
        </Button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
